<template>
  <div class="personal">
    <!-- 头部导航 -->
    <mt-header title="微校园">
      <router-link :to="{ name: 'Home' }" slot="left">
        <mt-button icon="back">
          <router-link :to="{ name: 'Home' }">
            <i class="iconfont icon-home"></i>
          </router-link>
        </mt-button>
      </router-link>
    </mt-header>

    <div class="global">
      <div class="base-line"></div>
      <div class="user-pr" v-for="item in data" :key="item.id">
        <div class="personal-intro-box">

          <label :for="item.userId" class="user-item flex flex-align-center">
            <div class="u-imgbox"><img :src="item.headPicUrl"></div>
            <div class="user-msg flex-1">
              <h2>{{ item.actualName }}</h2>
              <p>{{ item.identityName }}</p>
              <p>{{ ClassName }}</p>
            </div>
            <div class="personal-setting" v-if="item.userType == 3">
              <router-link :to="{ path: '/editor-my-intro' }">
                <img src="../../assets/images/setting.png" alt="">
              </router-link>
            </div>
          </label>
        </div>
        <!-- <input type="radio" :id="item.userId" name="user" :checked="current_user && current_user.userId==item.userId" class="iradio" style="display:none">
                <span class="iconfont icon-right"></span> -->
        <div class="ft-btn flex flex-pack-center" style="flex-wrap: wrap;">
          <!-- <router-link :to="{ path: '/official-account' }" class="u-btn unbind" style='margin-bottom: 8px; background-color: #165DFF;
          color: #fff;'>关注公众号</router-link> -->
          <router-link :to="{ path: 'changePwd', query: { userId: userId } }" class="u-btn unbind"
            style='margin-bottom: 8px;'>修改密码</router-link>
          <a class="u-btn unbind" @click="unbindAccount(item)" style='margin-bottom: 8px;'>切换账号</a>
          <div style="width:100%;text-align: center;" v-show="loginRole == 1">
            <a class="u-btn unbind" @click="openBindingPhone(item)" v-show="studentMobile == null"
              style='margin:0 auto 8px auto;'>绑定手机号码</a>
            <a class="u-btn unbind" @click="openChangePhone(item)" v-show="studentMobile != null"
              style='margin: 0 auto 8px auto;'>更换手机号码</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom-wrapper">
      <div class="nav-bottom flex flex-pack-around">
        <router-link :to="{ name: 'Home' }">
          <i class="iconfont icon-back"></i>
        </router-link>
        <router-link :to="{ name: 'Home' }">
          <i class="iconfont icon-home"></i>
        </router-link>
      </div>
    </div> -->

    <!-- 绑定手机号码 -->
    <div class="mint-msgbox" v-show="bindingPhoneModel" style="z-index: 2021;max-width:320px">
      <div class="mint-msgbox-header">
        <div class="mint-msgbox-title">绑定手机号码</div>
      </div>
      <div class="mint-msgbox-content">
        <div class="mint-msgbox-message">
          <div style="text-align: left;">
            <div style="font-size: 13px;">绑定的手机号码：
              <span v-show="usedPhone != null">{{ usedPhone }}</span>
              <span v-show="usedPhone == null">暂未绑定</span>
            </div>
            <div class="mint-msgbox-input" style="padding-top:5px">
              <input type="text" name="phone" placeholder="请输入手机号码" v-model="phone">
            </div>
            <div class="mint-msgbox-input" style="padding-top:5px">
              <input type="text" name="verifyCode" placeholder="请输入验证码" class="yzm" v-model="verifyCode">
              <button type="default" size="normal" class="btn" @click="sendVerifyCode(phone)">{{
                valiText }}</button>
            </div>
          </div>
        </div>
        <div style="color:red;text-align: center;font-size: 13px;padding-top:5px">{{ errorText }}</div>
      </div>
      <div class="mint-msgbox-btns">
        <button class="mint-msgbox-btn mint-msgbox-cancel " @click="closeBindingPhone">取消</button>
        <button class="mint-msgbox-btn mint-msgbox-confirm " @click="bindingPhoneOK">确定</button>
      </div>
    </div>

    <!-- 更换手机号 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2021;" v-show="changePhoneModel">
      <div class="mint-msgbox" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">更换手机号码</div>
        </div>
        <div class="mint-msgbox-content">
          <div class="mint-msgbox-message">
            <div style="text-align: left;">
              <div style="font-size: 13px;">旧手机号码：
                <span v-show="usedPhone != null">{{ usedPhone }}</span>
                <span v-show="usedPhone == null">暂未绑定</span>
              </div>
              <div class="mint-msgbox-input" style="padding-top:5px">
                <input type="text" name="mobile" placeholder="请输入旧手机号码" v-model="mobile">
              </div>
              <div class="mint-msgbox-input" style="padding-top:5px">
                <input type="password" name="mobilePass" placeholder="请输入登录密码" v-model="mobilePass">
              </div>
            </div>
          </div>
          <div style="color:red;text-align: center;font-size: 13px;padding-top:5px">{{ errorText }}</div>
        </div>

        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-cancel " @click="closeChangePhone()">取消</button>
          <button class="mint-msgbox-btn mint-msgbox-confirm " @click="nextChangePhone()">下一步</button>
        </div>
      </div>
    </div>

    <!-- 更换手机号下一步 -->
    <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 2021;" v-show="nextChangePhoneModel">
      <div class="mint-msgbox" style="max-width:320px">
        <div class="mint-msgbox-header">
          <div class="mint-msgbox-title">更换手机号码</div>
        </div>
        <div class="mint-msgbox-content">
          <div class="mint-msgbox-message">
            <div style="text-align: left;">
              <div class="mint-msgbox-input" style="padding-top:5px">
                <input type="text" name="phone" placeholder="请输入新手机号码" v-model="newMobile">
              </div>
              <div class="mint-msgbox-input" style="padding-top:5px;">
                <input type="text" name="verifyCode" placeholder="请输入验证码" class="yzm" v-model="securityCode">
                <button type="default" size="normal" class="btn" @click="sendVerifyCode(newMobile)">{{
                  valiText }}</button>
              </div>
            </div>
          </div>
          <div style="color:red;text-align: center;font-size: 13px;padding-top:5px">{{ errorText }}</div>
        </div>

        <div class="mint-msgbox-btns">
          <button class="mint-msgbox-btn mint-msgbox-cancel " @click="closeNextChangePhone()">取消</button>
          <button class="mint-msgbox-btn mint-msgbox-confirm " @click="nextChangePhoneOK()">下一步</button>
        </div>
      </div>
    </div>

    <div class="v-modal" style="z-index: 2020;" v-show="changePhoneModel || bindingPhoneModel || nextChangePhoneModel">
    </div>

  </div>
</template>

<style>
.mint-msgbox-wrapper .mint-msgbox-cancel {
  color: #000;
}

.mint-msgbox-input input {
  height: 25px !important;
}

.yzm {
  width: 60% !important;
}

.btn {
  background-color: rgb(61, 235, 177);
  color: #fff;
  padding: 8px;
  border-radius: 5px;
  font-size: 10px;
  width: 79px;
}
</style>

<script>
// 引入mint-ui  
import { MessageBox } from 'mint-ui';
import { Toast } from 'mint-ui';
//引入lodash库
import _ from 'lodash';
import { getUserInfo } from '../../service/user-service.js'
import default_avatar from '@/assets/images/user.png?20241114'
// const ip = require('ip');
// const IP = ip.address();

export default {
  data() {
    return {
      userId: this.$route.query.id,
      unbind: false,
      current_user: null,
      selected_user: null, // 当前点击的账号
      ClassName: null,
      data: [],
      loginRole: localStorage.getItem("loginRole"),//0:教师，1学生
      bindingPhoneModel: false,
      phone: null,
      verifyCode: null,
      time: 60,
      valiText: '获取验证码',
      studentMobile: null,
      usedPhone: null,
      mobile: null,
      mobilePass: null,
      changePhoneModel: false,
      errorText: null,
      nextChangePhoneModel: false,
      newMobile: null,
      securityCode: null,
    }
  },
  methods: {
    // selectedUser(user) {
    //     this.selected_user = user;
    //     this.unbind = true;
    //     // 切换账号
    //     this.$http.post('api/mobile/user/judgeBindWechat',
    //         {
    //             ip: IP,
    //             loginType: 'wechat',
    //             wechat: '123456',
    //             userId: this.selected_user.userId
    //         }
    //     ).then( res => {
    //         this.current_user = user; // 更新当前绑定的账户
    //         Toast('切换账号成功');
    //     });
    // },
    unbindAccount(user) {
      this.selected_user = user;
      MessageBox({
        title: '提示',
        message: '确定切换账号?',
        showCancelButton: true
      }).then(action => {
        if (action == 'confirm') {
          this.$http.get('/api/mobile/user/unbundlingWechat', { params: { userId: this.selected_user.userId } }).then(res => {
            if (res.data.code == 0) {
              var self = this;
              this.data = _.reject(this.data, function (user) {
                return user.userId == self.selected_user.userId;
              });
              // Toast('切换账号成功');
              if (this.data.length == 0) {
                this.$router.replace({ name: 'Login' });
                return;
              }
            } else {
              alert('切换账号失败,请重试!');
            }
          });
        }
      })
    },
    //打开绑定手机号弹框
    openBindingPhone() {
      this.bindingPhoneModel = true;
    },
    //关闭绑定手机号弹框
    closeBindingPhone() {
      this.phone = null;
      this.verifyCode = null;
      this.bindingPhoneModel = false;
      this.errorText = null;
    },
    //绑定手机号弹框确定
    bindingPhoneOK() {
      if (this.phone != null && this.phone != '' && this.verifyCode != null && this.verifyCode != '') {
        this.$http.post('/api/admin/user/boundStudentPhone', { mobile: this.phone, verifyCode: this.verifyCode }).then(res => {
          if (res.data.code == 0) {
            this.bindingPhoneModel = false;
            this.getStudent();
            Toast({
              message: '操作成功',
              iconClass: 'mint-toast-icon mintui mintui-success'
            });
          } else {
            this.errorText = res.data.message;
          }
        })
      } else {
        this.errorText = '手机号和验证码不能为空!';
      }
    },
    //打开更换手机号弹框
    openChangePhone() {
      this.changePhoneModel = true;
    },
    //关闭更换手机号弹框
    closeChangePhone() {
      this.mobile = null;
      this.mobilePass = null;
      this.changePhoneModel = false;
      this.errorText = null;
    },
    //更换手机号弹框下一步
    nextChangePhone() {
      if (this.mobile != null && this.mobile != '' && this.mobilePass != null && this.mobilePass != '') {
        if (this.mobile == this.studentMobile) {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          this.$http.get('/api/admin/user/nextMobilPhone', { params: { userId: userInfo.userId, mobile: this.mobile, mobilePass: this.mobilePass } }).then(res => {
            if (res.data.flag) {
              this.errorText = null;
              //打开更换手机号下一步弹框
              this.nextChangePhoneModel = true;
              //关闭更换手机号弹框
              this.changePhoneModel = false;
            } else {
              this.errorText = res.data.message;
            }
          })
        } else {
          this.errorText = '旧手机号不一致!';
        }
      } else {
        this.errorText = '手机号和密码不能为空!';
        return false;
      }
    },
    //关闭更换手机号下一步弹框
    closeNextChangePhone() {
      this.mobile = null;
      this.mobilePass = null;
      this.newMobile = null;
      this.securityCode = null;
      this.nextChangePhoneModel = false;
      this.errorText = null;
    },
    //更换手机号下一步弹框确定
    nextChangePhoneOK() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (this.newMobile != null && this.newMobile != '' && this.securityCode != null && this.securityCode != '') {
        this.$http.post('/api/admin/user/updateMobilePhone',
          {
            userId: userInfo.userId,
            userName: userInfo.userName,
            mobilePass: this.mobilePass,
            mobile: this.mobile,
            newMobile: this.newMobile,
            newVerifyCode: this.securityCode
          }).then(res => {
            if (res.data.code == 0) {
              Toast({
                message: '操作成功',
                iconClass: 'mint-toast-icon mintui mintui-success'
              });
              this.closeNextChangePhone();
              this.getStudent();
            } else {
              this.errorText = res.data.message;
            }
          })
      } else {
        this.errorText = '手机号和验证码不能为空!';
      }
    },
    getStudent() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.$http.get('/api/edu/student/getStudent?userId=' + userInfo.userId).then(res => {
        this.ClassName = res.data.className
        if (res.data.mobile != null && res.data.mobile != "" && res.data.mobile != undefined) {
          this.studentMobile = res.data.mobile;
          this.usedPhone = this.studentMobile.replace(/\D/g, '');  // 删除非数字字符
          if (/^\d{7,}$/.test(this.usedPhone)) {  // 校验手机号格式
            // 隐藏中间四位数
            this.usedPhone = this.usedPhone.replace(/^(\d{3})\d*(\d{4})$/g, '$1****$2');
          }
        } else {
          this.studentMobile = null;
        }
      })
    },
    getLoginCurDateCount() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.$http.post('/api/mobile/user/getLoginCurDateCount',
        {
          userId: userInfo.userId,
          schoolId: userInfo.schoolId,
          loginType: 'wechat'
        }
      ).then(res => {
        if (res.data.loginCount) {
          let loginCount = localStorage.getItem('loginCount');
          if (loginCount == null || loginCount == undefined) {
            loginCount = res.data.loginCount;
          }
          if ((loginCount == 1 || loginCount == "1") && (userInfo.mobile == null || userInfo.mobile == '')) {
            localStorage.setItem('loginCount', 2);
            this.openBindingPhone();
          }
        }
      })
    },
    //获取验证码
    sendVerifyCode(phone) {
      if (phone == null || phone == "" || phone == undefined) {
        this.errorText = '手机号码不能为空!';
        return false;
      }
      if (phone == this.studentMobile) {
        this.errorText = '新旧手机号码一致';
        return false;
      }
      this.$http.post('/api/admin/user/sendVerifyCode', { phone: phone, loginRole: this.loginRole }).then(res => {
        if (res.data.code == 0 || res.data.code == "0") {
          this.getTerm()
        } else {
          this.errorText = res.data.message;
        }
      })
    },
    getTerm() {
      if (this.time == 60) {
        let timer = setInterval(() => {
          if (this.time == 0) {
            clearInterval(timer);
            this.time = 60;
            this.valiText = '获取验证码';
          } else {
            this.valiText = this.time + '秒后重试';
            this.time--;
          }
        }, 1000);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.loginRole == 1) {
        this.getStudent();
        this.getLoginCurDateCount();
      }
      this.$http.get('/api/mobile/user/getUserByWechatAccount', { params: { wechat: '' } }).then(res => {

        this.data = _.map(res.data.data, user => {
          user.headPicUrl = user.headPicUrl || default_avatar;
          return user;
        });
      });
      // getUserInfo().then((user) => {
      //     this.current_user = user;
      // })     
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/user/ucenter.vue